import { ButtonV2 } from '@labrav/react-components'
import { EmptyState } from '../../common/components/EmptyState/EmptyState'
import Disable from '../../common/images/Disable.png'
import { useStyles } from './ChannelOffers.styles'
import { ChannelOffersDropDownWithModalTrigger } from './ChannelOfferDropdownWithModalTrigger/ChannelOffersDropdownWithModalTrigger'

export const SyncResaleAuthEmptyState = ({
  onSync,
  isLoadingSync,
  shouldDisplayWaitTime,
}: {
  onSync: () => void
  isLoadingSync: boolean
  shouldDisplayWaitTime: boolean
}) => {
  const { classes } = useStyles()
  return (
    <div
      className={classes.emptyStateContainer}
      data-testid="empty-sync-resale-card"
    >
      <EmptyState
        imgSrc={Disable}
        header="Get your Active Reseller authorizations"
        content={
          <div className={classes.emptyStateContent}>
            <p>
              Grow your revenue by getting your Reseller authorizations to enjoy
              effortless channel offer management and more benefits.
            </p>
          </div>
        }
        action={
          <div>
            <ButtonV2
              onClick={onSync}
              data-testid="button-sync-resale-authorizations"
              loading={isLoadingSync}
              disabled={!isLoadingSync && shouldDisplayWaitTime}
            >
              Sync authorizations from AWS
            </ButtonV2>
            {!isLoadingSync && shouldDisplayWaitTime && (
              <p className={classes.waitText}>
                Please wait for 5 mins and refresh the page as we sync
                authorizations meanwhile in background
              </p>
            )}
          </div>
        }
      />
    </div>
  )
}

export const CreateChannelOfferEmptyState = () => {
  const { classes } = useStyles()
  return (
    <div
      className={classes.emptyStateContainer}
      data-testid="empty-cppo-create-card"
    >
      <EmptyState
        imgSrc={Disable}
        header="Create your first channel offer"
        content={
          <div className={classes.emptyStateContent}>
            <p>
              Expand your revenue channel by creating your first channel offer.
              Boost your partner relations through channel offers, watch your
              partner network grow and unlock more benefits.
            </p>
          </div>
        }
        action={
          <div>
            <ChannelOffersDropDownWithModalTrigger dropDownButtonText="Create channel offer" />
          </div>
        }
      />
    </div>
  )
}
